var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDocumentSearch = function SvgDocumentSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96,
    height: 96,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#documentSearch_svg__a)",
    d: "M86 52.2c0-8.625-6.899-15.69-15.468-15.976V23.39c0-.336-.133-.66-.373-.898L55.412 7.762a1.27 1.27 0 0 0-.896-.371h-40.65c-.702 0-1.27.568-1.27 1.269v6.905H7.27c-.702 0-1.27.568-1.27 1.269v70.505c0 .702.568 1.27 1.27 1.27h54.292c.7 0 1.269-.568 1.269-1.27v-5.318h6.434c.7 0 1.269-.568 1.269-1.27v-12.57C79.1 67.894 86 60.824 86 52.2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M42.387 15.956h-20.26c-.702 0-1.27.568-1.27 1.27V37.46c0 .7.568 1.269 1.27 1.269h20.26c.7 0 1.269-.568 1.269-1.27V17.226a1.27 1.27 0 0 0-1.27-1.269"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#documentSearch_svg__b)",
    d: "M34.768 30.22c-.228 0-.327-.374-.15-.518a3.72 3.72 0 0 0 1.37-2.885 3.73 3.73 0 0 0-3.733-3.728 3.73 3.73 0 0 0-3.732 3.728c0 1.163.533 2.201 1.37 2.885.176.144.077.519-.15.519-2.585.022-4.691 2.14-4.691 4.725v2.68c0 .61.494 1.104 1.103 1.104h12.2c.61 0 1.103-.494 1.103-1.104v-2.68c.002-2.585-2.106-4.703-4.69-4.725"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#documentSearch_svg__c)",
    d: "M61.004 31.786H48.258a1.269 1.269 0 1 1 0-2.538h12.746a1.269 1.269 0 1 1 0 2.538"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#documentSearch_svg__d)",
    d: "M61.004 38.73H48.258a1.269 1.269 0 1 1 0-2.539h12.746a1.269 1.269 0 1 1 0 2.538"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#documentSearch_svg__e)",
    d: "M46.744 73.454H22.127a1.269 1.269 0 1 1 0-2.538h24.617a1.269 1.269 0 1 1 0 2.538"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#documentSearch_svg__f)",
    d: "M13.865 82.02a1.27 1.27 0 0 1-1.269-1.269V15.564H7.27c-.702 0-1.27.568-1.27 1.27v70.505c0 .701.568 1.27 1.27 1.27h54.292c.7 0 1.269-.569 1.269-1.27V82.02z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#documentSearch_svg__g)",
    d: "M55.412 7.762a1.26 1.26 0 0 0-.896-.368v14.885c0 .614.498 1.112 1.112 1.112H70.53c0-.33-.127-.655-.37-.898z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#documentSearch_svg__h)",
    d: "M34.768 30.22h-.992a3.7 3.7 0 0 1-1.52.324 3.7 3.7 0 0 1-1.522-.323h-.992c-2.584.022-4.69 2.14-4.69 4.725v3.784h14.406v-3.784c.002-2.585-2.106-4.703-4.69-4.725"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#documentSearch_svg__i)",
    d: "M22.127 52.62h31.868q-.005-.21-.005-.42c0-.718.05-1.426.141-2.119H22.127a1.269 1.269 0 1 0 0 2.538"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#documentSearch_svg__j)",
    d: "M22.127 45.676h33.26c.402-.892.884-1.742 1.436-2.538H22.127a1.269 1.269 0 1 0 0 2.538"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#documentSearch_svg__k)",
    d: "M59.18 63.97H22.128a1.269 1.269 0 1 0 0 2.539h38.16c.532 0 .987-.327 1.176-.792a16 16 0 0 1-2.282-1.746"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#documentSearch_svg__l)",
    d: "M22.127 59.565h33.67a16 16 0 0 1-1.058-2.538H22.127a1.269 1.269 0 1 0 0 2.538"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#ECEFF1",
    d: "M62.982 48.404a2.263 2.263 0 0 1 0-3.207 2.275 2.275 0 0 1 3.207 0l3.806 3.8 3.805-3.8a2.275 2.275 0 0 1 3.208 0c.888.886.888 2.32 0 3.207l-3.806 3.798 3.806 3.8c.888.887.888 2.321 0 3.208a2.275 2.275 0 0 1-3.208 0l-3.805-3.8-3.806 3.8a2.275 2.275 0 0 1-3.207 0 2.263 2.263 0 0 1 0-3.208l3.802-3.8z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#documentSearch_svg__m)",
    d: "M83.443 63.655a1.103 1.103 0 0 1 1.508-.039l9.033 8.038c1.626 1.603 1.685 4.157.134 5.695-1.55 1.535-4.117 1.471-5.726-.143l-8.92-7.989a1.103 1.103 0 0 1-.038-1.607z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#documentSearch_svg__n)",
    d: "M52 53.512c0-2.04.347-3.998.986-5.818C55.378 40.882 61.85 36 69.459 36c9.641 0 17.457 7.84 17.457 17.511 0 9.672-7.816 17.512-17.458 17.512S52 63.183 52 53.512"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M58.558 53.512c0-1.274.217-2.496.616-3.633 1.492-4.253 5.533-7.3 10.283-7.3 6.02 0 10.9 4.894 10.9 10.932s-4.88 10.934-10.9 10.934-10.9-4.895-10.9-10.933"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "documentSearch_svg__a",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-67.55 73.293 -67.93239 -62.60941 79.914 12.659)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BED7FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "documentSearch_svg__b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(130.826 13.094 20.517)scale(19.3734 16.741)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE0B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CD9A58"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "documentSearch_svg__c",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(166.376 27.122 18.17)scale(7.07416 3.87355)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9DC2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D7FEB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "documentSearch_svg__d",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(166.376 26.707 21.642)scale(7.07416 3.87355)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9DC2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D7FEB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "documentSearch_svg__e",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(172.232 17.585 36.912)scale(12.3285 3.94912)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9DC2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D7FEB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "documentSearch_svg__f",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-25.56426 47.95412 -47.61624 -25.38413 46.055 21.125)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9DC2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D7FEB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "documentSearch_svg__g",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(124.447 30.634 21.636)scale(12.736 14.2103)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9DC2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D7FEB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "documentSearch_svg__h",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-6.48055 5.58617 -6.60799 -7.66597 35.206 30.869)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9DC2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D7FEB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "documentSearch_svg__i",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-14.96755 1.66618 -.43825 -3.9369 44.31 50.274)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9DC2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D7FEB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "documentSearch_svg__j",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(174.12 21.99 22.852)scale(16.2641 3.96472)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9DC2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D7FEB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "documentSearch_svg__k",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(174.788 23.278 33.208)scale(18.3415 3.96921)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9DC2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D7FEB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "documentSearch_svg__l",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-15.71681 1.66633 -.41787 -3.94139 45.483 57.22)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9DC2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D7FEB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "documentSearch_svg__m",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(135.15 33.13 51.037)scale(20.6409 18.0271)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE0B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CD9A58"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "documentSearch_svg__n",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(133.078 32.431 36.706)scale(44.9421 39.1631)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE0B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CD9A58"
  })))));
};
export default SvgDocumentSearch;